export default "__VITE_ASSET__DcijCxcW__"